import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

import { MoreActionsButton } from '../../../..';
import theme from '../../../../../theme';
import { SearchboxElementType } from '../EditRateRecCategoryDrawer';

const useStyles = makeStyles(() => ({
  taggedAccounts: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: `solid ${theme.palette.primary.dark} 1px`,
    width: '100%',
    marginTop: '10px',
    padding: '3px',
    alignItems: 'center',
    '& > :first-child': {
      width: '50%',
      '& span': {
        backgroundColor: theme.palette.text.secondary,
        display: 'inline-block',
        padding: '3px',
        borderRadius: '4px',
        height: '28px',
        width: '143px',
        textAlign: 'center',
        color: theme.palette.common.white
      }
    },
    '& > :nth-child(2)': {
      width: '18%'
    },
    '& > :nth-child(3)': {
      width: '18%'
    },
    '& > :nth-child(4)': {
      width: '5%'
    }
  },
  scrollContainer: {
    height: '530px',
    overflowY: 'auto'
  },
  taggedAccountElement: {
    display: 'flex',
    flexDirection: 'row',
    height: '45px',
    alignItems: 'center',
    borderBottom: `solid 1px ${theme.palette.divider}`,
    '& >  :first-child': {
      width: '15%'
    },
    '& >  :nth-child(2)': {
      width: '38%'
    },
    '& >  :nth-child(3)': {
      width: '20%'
    },
    '& >  :nth-child(4)': {
      width: '20%'
    },
    '& >  :nth-child(5)': {
      width: '5%'
    },
    '& >  :nth-child(6)': {
      width: '8%'
    }
  }
}));

const stepNameToLabel: Record<string, string> = {
  'federal.credits': 'Federal Credits',
  'federal.permanent': 'Federal Permanent',
  'federal.tax-effected': 'Federal Tax-Effected'
};

interface TaggedItemsProps {
  selectedAccountsEntityCount: SearchboxElementType[];
  deleteAccountFromCategory: (
    accountName: string,
    stepName?: string | undefined,
    dataCategory?: string | null | undefined
  ) => void;
}

const TaggedItems = ({ selectedAccountsEntityCount, deleteAccountFromCategory }: TaggedItemsProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={classes.taggedAccounts}>
        <Box>
          <span>
            {selectedAccountsEntityCount?.length ?? 0} {t('Tagged Items')}
          </span>
        </Box>
        <Box>
          <span>
            Data
            <br />
            Type
          </span>
        </Box>
        <Box>
          <span>
            Data
            <br />
            Category
          </span>
        </Box>
        <Box>{t('Entities')}</Box>
      </Box>
      <Box className={classes.scrollContainer}>
        {selectedAccountsEntityCount?.map(
          ({ accountNumber, name, count, stepName, dataCategory }: SearchboxElementType) => {
            const label = stepName && typeof stepName === 'string' ? stepNameToLabel[stepName] : '';
            return (
              <Box key={`${name}-${accountNumber ?? ''}`} className={classes.taggedAccountElement}>
                <Box>{accountNumber}</Box>
                <Box>{name}</Box>
                <Box>{label ?? ''}</Box>
                <Box>{dataCategory}</Box>
                <Box>x{count}</Box>
                <MoreActionsButton
                  actions={[
                    {
                      label: t('Remove'),
                      onClick: () => {
                        deleteAccountFromCategory(name, stepName, dataCategory);
                      }
                    }
                  ]}
                />
              </Box>
            );
          }
        )}
      </Box>
    </>
  );
};

export default TaggedItems;
